import { render, staticRenderFns } from "./InformesProgreso.vue?vue&type=template&id=510fe19a&scoped=true"
import script from "./InformesProgreso.vue?vue&type=script&lang=js"
export * from "./InformesProgreso.vue?vue&type=script&lang=js"
import style0 from "./InformesProgreso.vue?vue&type=style&index=0&id=510fe19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510fe19a",
  null
  
)

export default component.exports